<template>
  <div>
    <CRow>
      <CCol md="12">
        <div v-if="userType === 'Verifier'">
          <staff-calendar></staff-calendar>
        </div>
        <div v-if="userType === 'Admin'">
          <calendar-view></calendar-view>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";
import store from "/src/store/store.js";
import {
  dashboardProfileList,
  dashboardNumberOfEntitiesList,
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import StaffCalendar from "/src/views/profile/StaffCalendar";
import CalendarView from "../calendar/CalendarView.vue";
Vue.use(ServerTable, {}, false);
Vue.use(VueTelInput);

export default {
  name: "CalendarMain",
  mixins: [Mixin],
  components: {
    StaffCalendar,
    CalendarView,
  },
  data() {
    return {
      alertMessage: "",
      userType: localStorage.getItem("roleName"),
      role : localStorage.getItem("roleName"),
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      dismissCountDownS: 0,
      self: this,
      count: 0,
      moduleDashboardProfileList: dashboardProfileList,
      moduleDashboardNumberOfEntitiesList: dashboardNumberOfEntitiesList,
      locationText: "",
      showProfile: false,
      phone: "",
      dismissCountDown: 0,
      submitStatus: null,
      selected: "Month",
      entitiesNumber: [],
      VerifierData:[],
      tableItems: [],
      listUrl: "/dashboard/profile/requests/list/",
      tableFields: [
        {key: "avatar", label: "", _classes: "text-center"},
        {key: "user"},
        {key: "industry"},
        {key: "country", _classes: "text-center"},
        {key: "registered"},
      ],
      columns: ["name", "status", "addedRequest", "actions"], //'title','company'
      data: [],
      options: {
        headings: {
          name: this.$lang.profileRequest.table.name,
          status: this.$lang.profileRequest.table.status,
          addedRequest: this.$lang.profileRequest.table.addedRequest,
        },
        editableColumns: ["name", "isVerified"],
        sortable: ["name", "isVerified"],
        filterable: ["name", "isVerified"],
      },
    };
  },
  validations: {

  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios
        .get(this.listUrlApi(this.moduleDashboardProfileList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.length > 0) {
            self.showProfile = true;
          }
        });
    axios
        .get(this.listUrlApi(this.moduleDashboardNumberOfEntitiesList))
        .then((response) => {
          self.entitiesNumber = response.data.data;
          self.VerifierData = response.data.data.verifierData;
        });
  },

  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `profile/view/${item.user.id}`});
    },
    viewProfiles() {
      this.$router.push({path: "profile"});
    },
    gotoPage(page) {
      if(page!="") {
        this.$router.push({path: page});
      }
    },
  },
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
